<div class="manage-contribution-container">
  
  <!-- Loading overlay - blocks interactions while API is pending -->
  <div *ngIf="loading" class="manage-contribution-loading-overlay" aria-hidden="true"></div>

  <!-- Filter Section -->
  <app-filter-panel
    [fields]="filterFields"
    [defaultExpanded]="false"
    (filterChange)="onFilterChange($event)"
    (clearFilters)="onClearFilters()"
  ></app-filter-panel>

  <!-- Table -->
  <app-table
    [columns]="columns"
    [data]="contributionsData"
    [scrollHeight]="'400px'"
    [loading]="loading"
    [pagination]="pagination"
    [emptyMessage]="emptyMessage"
    [striped]="true"
    [bordered]="true"
    [hoverable]="true"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
    (sortChange)="onSortChange($event)"
  >
    <!-- Custom Publish Status Column: Visible (green) / Hidden (red) -->
    <ng-template #statusCell let-row>
      <div class="publish-status-cell">
        <span [ngClass]="getStatusIndicatorClass(row.status)"></span>
        <span class="publish-status-label">{{ getPublishStatusDisplayLabel(row.status) }}</span>
      </div>
    </ng-template>

    <!-- Custom Permission Column -->
    <ng-template #permissionCell let-row>
      <div [ngClass]="getPermissionBadgeClass(row.permission)">
        <img src="/public.svg" alt="Permission" class="permission-badge-icon" *ngIf="row.permission && (row.permission.toUpperCase() === 'PUBLIC' || row.permission.toUpperCase() === 'OPEN' || row.permission.toUpperCase() === 'RESTRICTED')"/>
        <img src="/filters/lock.svg" alt="Private" class="permission-badge-icon" *ngIf="row.permission && row.permission.toUpperCase() === 'PRIVATE'"/>
        <span>{{ getPermissionLabel(row.permission) }}</span>
      </div>
    </ng-template>

    <!-- Custom Action Column (dropdown rendered in fixed overlay below) -->
    <ng-template #actionCell let-row>
      <div class="action-cell-wrapper">
        <button 
          class="action-btn" 
          appActionDropdownTrigger
          (click)="toggleActionDropdown($event, row)"
          [class.active]="isDropdownOpen(row)"
        >
          <span>Action</span>
        </button>
      </div>
    </ng-template>
  </app-table>
</div>

<!-- Fixed overlay: dropdown on top of table -->
<div
  *ngIf="overlayPosition && openDropdownRow"
  class="action-dropdown-overlay"
  [style.top.px]="overlayPosition.top"
  [style.left.px]="overlayPosition.left"
  [style.min-width.px]="overlayPosition.width"
  (click)="$event.stopPropagation()"
>
  <ul class="dropdown-list">
    <li class="dropdown-item">
      <button type="button" class="dropdown-link" (click)="handleAction('view', openDropdownRow)">View</button>
    </li>
    <ng-container *ngIf="actionContext === 'provider'">
      <li class="dropdown-item">
        <button type="button" class="dropdown-link" (click)="handleAction('modifyMetadata', openDropdownRow)">Modify Metadata</button>
      </li>
      <li class="dropdown-item" *ngIf="isManageFilesAssetType(openDropdownRow)">
        <button type="button" class="dropdown-link" (click)="handleAction('manageFiles', openDropdownRow)">Manage Files</button>
      </li>
      <li class="dropdown-item">
        <button type="button" class="dropdown-link" (click)="handleAction('delete', openDropdownRow)">Delete Asset</button>
      </li>
    </ng-container>
    <ng-container *ngIf="actionContext !== 'provider'">
      <li class="dropdown-item" *ngIf="openDropdownRow.status === 'Granted'">
        <button type="button" class="dropdown-link" (click)="handleAction('hide', openDropdownRow)">Hide</button>
      </li>
      <li class="dropdown-item" *ngIf="openDropdownRow.status === 'Pending'">
        <button type="button" class="dropdown-link" (click)="handleAction('unhide', openDropdownRow)">Unhide</button>
      </li>
      <li class="dropdown-item" *ngIf="isManageFilesAssetType(openDropdownRow)">
        <button type="button" class="dropdown-link" (click)="handleAction('manageFiles', openDropdownRow)">Manage Files</button>
      </li>
      <li class="dropdown-item">
        <button type="button" class="dropdown-link" (click)="handleAction('delete', openDropdownRow)">Delete</button>
      </li>
    </ng-container>
  </ul>
</div>

<app-manage-files-modal
  *ngIf="showManageFilesModal && manageFilesModalRow"
  [itemId]="getManageFilesItemId(manageFilesModalRow)"
  [assetName]="manageFilesModalRow.assetName"
  (dismiss)="closeManageFilesModal()"
></app-manage-files-modal>

<!-- Delete Confirmation Modal -->
<app-confirmation-dialog
  [(visible)]="showDeleteConfirmModal"
  type="delete"
  themeColor="red"
  title="Delete Asset"
  [message]="rowToDelete ? 'Are you sure you want to delete &quot;' + (rowToDelete.assetName || 'this asset') + '&quot;? This action cannot be undone.' : ''"
  confirmLabel="Delete"
  cancelLabel="Cancel"
  [loading]="isDeleting"
  (onConfirm)="onConfirmDelete()"
  (onCancel)="onCancelDelete()"
></app-confirmation-dialog>

<!-- Modify Metadata Modal (provider context) -->
<app-modal
  [(visible)]="showModifyModal"
  header="Modify Asset Metadata"
  [width]="'900px'"
  [showFooter]="false"
  (onCancel)="closeModifyModal()"
>
  <div *ngIf="isLoadingAssetData" class="modify-metadata-loading">
    <p>Loading asset data...</p>
  </div>
  <app-provider-preview-metadata
    *ngIf="!isLoadingAssetData && modifyAssetData"
    [editableMode]="true"
    [allowSaveWithoutDirty]="true"
    [assetData]="modifyAssetData"
    [assetType]="getAssetTypeForModify()"
    (formSubmit)="onModifyFormSubmit($event)"
    (formCancel)="onModifyFormCancel()"
  ></app-provider-preview-metadata>
</app-modal>
